import { type RouteObject } from 'react-router'

import {
  KEYWORDS_DETAIL_TRANSACTION_PATH,
  KEYWORDS_DETAIL_URL,
  KEYWORDS_TRANSACTION_PATH,
  KEYWORDS_URL,
} from 'features/keywords/paths'
import { lazyDefault } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
const keywordsPage = (): ReturnType<typeof lazyDefault> =>
  lazyDefault(() => import('features/keywords/Container'))

export const keywordsRoutes: RouteObject[] = [
  {
    path: KEYWORDS_URL,
    lazy: keywordsPage(),
    handle: {
      featureKey: KEYWORDS_URL,
      sentryTransactionPath: KEYWORDS_TRANSACTION_PATH,
    },
  },
  {
    path: `${KEYWORDS_URL}/:keywordsId`,
    lazy: keywordsPage(),
    handle: {
      featureKey: KEYWORDS_DETAIL_URL,
      sentryTransactionPath: KEYWORDS_DETAIL_TRANSACTION_PATH,
    },
  },
]
